import React from 'react';
import propTypes from 'prop-types';
import { DrawerBody, Typography } from '@one-thd/sui-atomic-components';
import { useMessage } from '../../../hooks/useMessage';
import { usePromoModel } from '../../../hooks/usePromoModel';
import { MESSAGE_KEY } from '../../../utils/constants';
import { BmsmTiers } from '../../BmsmTiers/BmsmTiers';
import { PromoDrawerHeader } from './subcomponents/PromoDrawerHeader';

const { func } = propTypes;

export const PromoSummaryDrawer = ({ onBack, onClose }) => {
  const {
    isBmsm,
    longDesc,
    shortDesc,
    isBogoPair,
  } = usePromoModel();
  const templateTitle = useMessage(MESSAGE_KEY.title);
  const pairTitle = useMessage(MESSAGE_KEY.pairTitle);
  const title = isBogoPair ? pairTitle : templateTitle;
  const promoSummarySubtitle = useMessage(MESSAGE_KEY.promoSummarySubtitle);
  return (
    <>
      <PromoDrawerHeader
        title={title}
        onBack={onBack}
        onClose={onClose}
      />
      <DrawerBody>
        <article
          className="sui-pr-2 sui-flex sui-flex-col sui-gap-2"
          data-testid="promo-summary"
        >
          <Typography component="p" variant="h4">{promoSummarySubtitle}</Typography>
          <div className="sui-flex sui-flex-col sui-gap-1">
            <Typography> {shortDesc} </Typography>
            <Typography> {longDesc} </Typography>
          </div>
          {isBmsm && <BmsmTiers />}
        </article>
      </DrawerBody>
    </>
  );
};

PromoSummaryDrawer.displayName = 'PromoSummaryDrawer';

PromoSummaryDrawer.propTypes = {
  onBack: func.isRequired,
  onClose: func.isRequired
};
